import type { UifConfig, TaxYear } from '../../types/tax';

export const UIF_CONFIG_2024_25: UifConfig = {
  employeeRate: 0.01,      // 1%
  employerRate: 0.01,      // 1%
  monthlyCapAmount: 17712  // R17,712 per month cap
};

export const UIF_CONFIG_2025_26: UifConfig = {
  employeeRate: 0.01,      // 1%
  employerRate: 0.01,      // 1%
  monthlyCapAmount: 17712  // R17,712 per month cap (unchanged)
};

export const UIF_CONFIG_2026_27: UifConfig = {
  employeeRate: 0.01,      // 1%
  employerRate: 0.01,      // 1%
  monthlyCapAmount: 18240  // R18,240 per month cap (increased for 2026-27)
};

export const UIF_ANNUAL_CAP = UIF_CONFIG_2024_25.monthlyCapAmount * 12; // R212,544

export function getUIFConfigForTaxYear(taxYear: TaxYear): UifConfig {
  switch (taxYear) {
    case '2026-27':
      return UIF_CONFIG_2026_27;
    case '2025-26':
      return UIF_CONFIG_2025_26;
    case '2024-25':
    case '2023-24':
    default:
      return UIF_CONFIG_2024_25;
  }
}